"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedGeoFenceSelectors = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _immutable = require("immutable");
var _general = require("./general");
// Selectors generally designed to cache processed data for any part of the code
/*global google*/

function genGeoFenceDefSelector() {
  return (0, _general.immutableSelectorCreator)([geoFence => geoFence], geoFence => {
    let ext;
    if (geoFence.get('bounding_polygon')) {
      const def = geoFence.get('bounding_polygon').toJS();
      const gPoly = new google.maps.Polygon({
        paths: def
      });
      const gBounds = new google.maps.LatLngBounds();
      (0, _forEach.default)(def).call(def, point => gBounds.extend(point));
      ext = {
        gPoly,
        gBounds
      };
    } else if (geoFence.get('bounding_box')) {
      const gRect = new google.maps.Rectangle({
        bounds: geoFence.get('bounding_box').toJS()
      });
      ext = {
        gRect,
        gBounds: gRect.getBounds()
      };
    } else if (geoFence.get('bounding_circle')) {
      const def = geoFence.get('bounding_circle').toJS();
      const gCir = new google.maps.Circle({
        center: {
          lat: def.center.lat,
          lng: def.center.lon
        },
        radius: def.radius
      });
      ext = {
        gCir,
        gBounds: gCir.getBounds()
      };
    }
    return geoFence.merge((0, _immutable.Map)(ext));
  });
}
const sharedGeoFenceSelectors = (0, _general.genKeyedSelector)(genGeoFenceDefSelector, geofence => geofence.get('id'));
exports.sharedGeoFenceSelectors = sharedGeoFenceSelectors;